import { render } from "./PortfolioWebDesign.vue?vue&type=template&id=2c904334&scoped=true"
import script from "./PortfolioWebDesign.vue?vue&type=script&lang=js"
export * from "./PortfolioWebDesign.vue?vue&type=script&lang=js"

import "./PortfolioWebDesign.vue?vue&type=style&index=0&id=2c904334&scoped=true&lang=css"
import "./PortfolioWebDesign.vue?vue&type=style&index=1&id=2c904334&scoped=true&lang=css"
import "./PortfolioWebDesign.vue?vue&type=style&index=2&id=2c904334&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c904334"]])

export default __exports__